
<div class="heading-tab">
  <h3 class="heading"><i nz-icon nzType="medicine-box" nzTheme="outline"></i> Hospital Details</h3>
  <button nz-button nzType="primary" (click)="modHospDetails=true">Add Hospital Details</button>
</div>
<nz-table [nzData]="dataSet" [nzShowPagination]="false">
  <thead>
    <tr>
      <th>Name of Hospital</th>
      <th>Hospital Details</th>
      <th>Address</th>
      <th>Date of Admission</th>
      <th>Date of Discharge</th>
      <th>Treated For</th>
      <th>Actions</th>
    </tr>
  </thead> 
  <tbody>
    <tr>
      <td>Fort Speciality</td>
      <td>Partner Hosp.</td>
      <td>Grand Trunk Road, Marine Drive, KD 2910</td>
      <td>12 Jan 2019</td>
      <td>15 Jan 2019</td>
      <td>Sudden chest pain</td>
      <td><a>Edit</a> | <a nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove"
          nzCancelText="Cancel">Remove</a></td>
    </tr>
    <tr>
      <td>Fort Speciality</td>
      <td>Partner Hosp.</td>
      <td>Grand tdunk Road, Marine Drive, KD 2910</td>
      <td>15 Jan 2019</td>
      <td>25 Jan 2019</td>
      <td>Angioplasty</td>
      <td><a>Edit</a> | <a nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove"
          nzCancelText="Cancel">Remove</a></td>
    </tr>
  </tbody>
</nz-table>


<!-- Hospital Details : Add -->
<nz-modal [(nzVisible)]="modHospDetails" nzTitle="Add Hospital Details" (nzOnCancel)="modHospDetails=false"
  (nzOnOk)="modHospDetails=false" nzOkText="Add" nzWidth="75%">
  <div *ngIf="modHospDetails">
    <div class="tab-grid m-t-20">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Hospital</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  [ngModel]="'Fort Speciality'" style="width: 100%">
            <nz-option [nzLabel]="'Fort Speciality'" [nzValue]="'Fort Speciality'"></nz-option>
            <nz-option [nzLabel]="'Sacred Hearts'" [nzValue]="'Sacred Hearts'"></nz-option>
            <nz-option [nzLabel]="'Our Lady Peace'" [nzValue]="'Our Lady Peace'"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Hospital Address</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input nzAutosize placeholder="Address"></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Hospital Details</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input nzAutosize placeholder="Additional Details"></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Date of Admission</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Date of Discharge</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Treated for</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input nzAutosize placeholder="Details of treatment"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

  </div>
</nz-modal>